.modal-body {
  line-height: 1.5;
  height: 700px;
  overflow-y: hidden;
}

.start-step-wizard {
  padding: 0 !important;
  overflow-x: hidden;
}

.step-content {
  width: 100%;
}

.header {
  font-size: 20px;
  color: var(--default--modal-header--text-color--2);
  padding-top: 6px;
  padding-bottom: 12px;
  line-height: 25px;
}

.pickup-header {
  margin-bottom: var(--space-16);
}
.wallet-registration-modal {
  @media (--tablet), (--desktop), (--widescreen), (--ultrawide) {
    width: 480px;
  }
}
